import Vote from './Vote';
export default Vote;